export enum EProductEditions {
  Enterprise = 'Enterprise',
  PlateViewer = 'Plate Viewer',
  ExperimentDesigner = 'Experiment Designer',
}
